<div>
    <div class="sos-text-input">
        <ng-content select="serviceos-ng-label"></ng-content>
        <ng-content select="input[type=text], input[type=password], textarea"></ng-content>
        <ng-content select="serviceos-ng-error-message"></ng-content>
    </div>
    <ng-content select="serviceos-ng-description"></ng-content>
</div>